export default class Misc{
	constructor(){
		const btns = document.querySelectorAll("a.roundarrowbtn, a.circlearrowbtn, a.linkline");
		btns.forEach(btn=>{
			if(btn.getAttribute("target") != "_blank"){
				btn.addEventListener("click", ()=>{ btn.classList.add("clicked"); }, false);
			}
		});


		window.addEventListener('pageshow', ()=>{
			const btns = document.querySelectorAll("a.roundarrowbtn.clicked, a.circlearrowbtn.clicked, a.linkline.clicked");
			btns.forEach(btn=>{
				btn.classList.remove("clicked")
			});
		});
	}
}